import ApiError from '~/utils/error/ApiError';
import { SIGN_IN } from '~/ui/constants/paths';

// perform logout, clear storage and redirect to login page
const forceLogout = (): Promise<never> => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.replace(SIGN_IN);

  return Promise.reject(
    new ApiError({ message: 'Unable to restore session. Please login again' }, { url: SIGN_IN }),
  );
};

export default forceLogout;
